import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { CornerRegularFrameComponent } from '../../platform/components/CornerRegularFrameComponent';
export const isEntityFrame = (entity) => entity.hasComponent(ComponentIds.FRAME_COMPONENT_ID) ||
    entity.hasComponent(CornerRegularFrameComponent.id);
export const getEntityFrame = (entity) => isEntityFrame(entity) ? entity : HierarchyUtils.findInUpwardsHierarchy(entity, isEntityFrame);
//# sourceMappingURL=getEntityFrame.js.map